import { AdSlot, type AdSlotProps } from "./AdSlot";

export type NativeAdProps = Omit<AdSlotProps, "format" | "minHeight"> & {
  /** 広告の見た目バリアント */
  variant?: "card" | "inline";
};

/**
 * フィード内ネイティブ広告
 * リストアイテムの間に自然に溶け込む広告
 */
export function NativeAd({ variant = "card", className = "", ...props }: NativeAdProps) {
  const baseClass =
    variant === "card" ? "my-4 rounded-xl border bg-card p-4 shadow-sm" : "my-2 py-2";

  return (
    <div className={`${baseClass} ${className}`}>
      <div className="mb-1 text-[10px] uppercase tracking-wider text-muted-foreground">広告</div>
      <AdSlot {...props} format="auto" minHeight={variant === "card" ? 120 : 80} />
    </div>
  );
}
